import { apiClient } from './apiClient';

const asList = (data) => data?.results || data || [];

const standByService = {
  listar: async (params = {}) => {
    const response = await apiClient.get('/stand-by-equipos/', { params });
    return response.data;
  },

  listarSimple: async (params = {}) => {
    const response = await apiClient.get('/stand-by-equipos/', { params });
    return asList(response.data);
  },

  crear: async (payload) => {
    const response = await apiClient.post('/stand-by-equipos/', payload);
    return response.data;
  },

  actualizar: async (id, payload) => {
    const response = await apiClient.patch(`/stand-by-equipos/${id}/`, payload);
    return response.data;
  },

  eliminar: async (id) => {
    await apiClient.delete(`/stand-by-equipos/${id}/`);
  },

  reabrir: async (id) => {
    const response = await apiClient.post(`/stand-by-equipos/${id}/reabrir/`);
    return response.data;
  },

  salir: async (id, payload = {}) => {
    const response = await apiClient.post(`/stand-by-equipos/${id}/salir/`, payload);
    return response.data;
  },

  // { equipos: [ids], fecha_inicio, motivo, observaciones } → { creados, ya_en_stand_by }
  entrarMasivo: async (payload) => {
    const response = await apiClient.post('/stand-by-equipos/masivo/', payload);
    return response.data;
  },

  // { equipos: [ids], fecha_fin } → { cerrados }
  salirMasivo: async (payload) => {
    const response = await apiClient.post('/stand-by-equipos/salir-masivo/', payload);
    return response.data;
  },
};

export default standByService;
